import styled from '@emotion/styled';
import React from 'react';
import {mixinFlexboxColumn, mixinSVGIcon} from 'webapp-lib/styling';

import {Info} from '_/assets/images';

export const ConfirmationMessageWithInfoText = ({
  confirmMessage,
  infoText,
}: {
  confirmMessage: string;
  infoText: string;
}): React.ReactElement => (
  <ConfirmationMessageWithInfoTextWrapper>
    <p>{confirmMessage}</p>
    <InfoText text={infoText} />
  </ConfirmationMessageWithInfoTextWrapper>
);

export const InfoText = ({text}: {text: string}): React.ReactElement => (
  <InfoTextWrapper>
    <Info />
    <span>{text}</span>
  </InfoTextWrapper>
);

const InfoTextWrapper = styled.div`
  display: flex;
  gap: var(--gutter-little);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-thin);

  svg {
    ${mixinSVGIcon};
  }
`;

const ConfirmationMessageWithInfoTextWrapper = styled.div`
  ${mixinFlexboxColumn};
  gap: var(--gutter);
`;
